import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Subject, takeUntil } from 'rxjs';
import { AuthBagService } from '../../../auth/auth-bag.service';
import { Injectable } from '@angular/core';

@Injectable()
export class DocumentDownloader {
	constructor(
		private readonly auth: AuthBagService,
		private readonly httpClient: HttpClient,
	) {}

	documentUnsubscribe$ = new Subject<void>();

	private get httpHeaders(): HttpHeaders {
		return new HttpHeaders({
			'Content-Type': 'application/pdf',
			Authorization: `Bearer ${this.auth.tokenGet()}`,
		});
	}

	async download(documentId: number): Promise<boolean> {
		return new Promise((resolve, reject) => {
			const url = `${environment.apiUrl}/document/${documentId}/pdf/`;
			this.httpClient
				.get(url, {
					headers: this.httpHeaders,
					responseType: 'blob',
					observe: 'events',
				})
				.pipe(takeUntil(this.documentUnsubscribe$))
				.subscribe({
					next: (event) => {
						if (event.type === HttpEventType.Response) {
							this.openBlobFromResponse(event);
							resolve(true);
						}
					},
					error: (error) => {
						reject(false);
						throw new Error(error);
					},
				});
		});
	}

	async fetchDocument(documentId: number): Promise<any> {
		return new Promise((resolve, reject) => {
			const url = `${environment.apiUrl}/document/${documentId}/pdf/`;
			this.httpClient
				.get(url, {
					headers: this.httpHeaders,
					responseType: 'blob',
					observe: 'events',
				})
				.pipe(takeUntil(this.documentUnsubscribe$))
				.subscribe({
					next: (event) => {
						if (event.type === HttpEventType.Response) {
							resolve(event.body);
						}
					},
					error: (error) => {
						reject(false);
						throw new Error(error);
					},
				});
		});
	}

	private openBlobFromResponse(event: any): void {
		const blob = new Blob([event.body as BlobPart], {
			type: 'application/pdf',
		});
		const url = window.URL.createObjectURL(blob);
		window.open(url, '_blank');
	}
}
